import GoodCompanyCommunication from '~/pages/communication/goodCompany/libs/components/GoodCompanyCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const GoodCompanyCommunicationPage = (props: TPageProps) => (
  <GoodCompanyCommunication {...props} />
)

export default GoodCompanyCommunicationPage
